module.exports = __webpack_public_path__ + "static/media/icon-football-black.b27f657c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/preview/icon-football-black.svg
// module id = ./src/assets/images/preview/icon-football-black.svg
// module chunks = 0